import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    document.title = "Rappholtphoto – Bröllopsfilmare i Skåne";
  }, []);

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-20">
        <nav className="flex justify-between items-center px-6 py-4 bg-black/30 backdrop-blur-sm text-white">
          <a href="/" className="flex items-center gap-2">
            <img
              src="/Jensphoto2.png"
              alt="Rappholtphoto Logo"
              className="h-10 w-auto"
            />
          </a>
          <ul className="flex gap-6 text-sm font-medium">
            <li><a href="#showreel" className="hover:text-gray-300 transition">Showreel</a></li>
            <li><a href="#packages" className="hover:text-gray-300 transition">Paket</a></li>
            <li><a href="#about" className="hover:text-gray-300 transition">Om Mig</a></li>
            <li><a href="#contact" className="hover:text-gray-300 transition">Kontakt</a></li>
          </ul>
        </nav>
      </header>

      <main className="bg-white text-black font-sans">
        {/* Hero Section with Background Video */}
        <section className="relative h-screen w-full overflow-hidden">
          <video
            className="absolute top-0 left-0 w-full h-full object-cover"
            src="/hero-video.mp4"
            autoPlay
            muted
            loop
            playsInline
          />
          <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6 bg-black/50 text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-4">Cinematiska bröllopsfilmer</h1>
            <p className="text-xl md:text-2xl mb-6">För ögonblicken som betyder mest</p>
            <a href="#showreel" className="inline-block bg-white text-black py-3 px-6 rounded-lg hover:bg-gray-200 transition">
              Se Showreel
            </a>
          </div>
        </section>

        {/* Showreel Section */}
        <section id="showreel" className="py-20 px-6 bg-gray-100 text-center">
  <h2 className="text-3xl font-semibold mb-8">Showreel</h2>
  <div className="max-w-4xl mx-auto aspect-video">
    <iframe
      className="w-full h-full rounded-xl shadow-lg"
      src="https://www.youtube.com/embed/jpJq3PGnw5s"
      title="Rappholtphoto Showreel"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>
</section>

{/* Full Wedding Film */}
<section className="py-20 px-6 bg-white text-center">
  <h2 className="text-3xl font-semibold mb-6">Tapomita och Maximillian</h2>
  <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
    Upplev ett riktigt bröllop från början till slut – berättat genom min kamera, med ljud, känsla och ögonblicken som betyder mest.
  </p>
  <div className="max-w-5xl mx-auto aspect-video">
    <iframe
      className="w-full h-full rounded-xl shadow-lg"
      src="https://www.youtube.com/embed/6XhBUA2cDzM"
      title="Full Wedding Film by Rappholtphoto"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>
</section>

        {/* Packages Section */}
        <section id="packages" className="py-20 px-6 bg-white text-center">
          <h2 className="text-3xl font-semibold mb-10">Paket</h2>
          <div className="grid gap-8 max-w-5xl mx-auto md:grid-cols-3">
            <div className="border rounded-xl p-6 shadow-md">
              <h3 className="text-xl font-bold mb-4">Highlightfilm</h3>
              <p className="text-lg mb-2">Från 14 000 SEK</p>
              <ul className="text-left list-disc list-inside text-sm text-gray-700">
                <li>4–6 minuters highlightvideo</li>
                <li>Halvdagsfilmning</li>
                <li>Berättande och känslofylld stil</li>
              </ul>
            </div>

            <div className="border rounded-xl p-6 shadow-md">
              <h3 className="text-xl font-bold mb-4">Heldagsfilmning</h3>
              <p className="text-lg mb-2">Från 22 000 SEK</p>
              <ul className="text-left list-disc list-inside text-sm text-gray-700">
                <li>10–12 timmars filmning</li>
                <li>Highlightfilm + full vigsel</li>
                <li>Licensierad musik och drönarbilder</li>
              </ul>
            </div>

            <div className="border rounded-xl p-6 shadow-md">
              <h3 className="text-xl font-bold mb-4">Destinationbröllop</h3>
              <p className="text-lg mb-2">Pris enligt offert</p>
              <ul className="text-left list-disc list-inside text-sm text-gray-700">
                <li>Över hela Europa (och längre)</li>
                <li>Anpassad planering och logistik</li>
                <li>Flexibla upplägg</li>
              </ul>
            </div>
          </div>
          <p className="text-sm text-gray-600 mt-6 max-w-xl mx-auto">
            Alla priser är frånpriser och kan variera beroende på plats, tillval och önskemål. Kontakta mig för en skräddarsydd offert.
          </p>
        </section>

        {/* About Section */}
        <section id="about" className="py-20 px-6 bg-white text-center">
          <h2 className="text-3xl font-semibold mb-6">Om Mig</h2>
          <p className="max-w-2xl mx-auto text-lg">
            Jag heter Jens och arbetat som yrkesfotogaf tidigare och har nu gått över till att filma helt och är en filmare som brinner för att skapa känslomässiga, berättande bröllopsfilmer. Basen är i Skåne – men jag filmar över hela Sverige och Europa.
          </p>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-20 px-6 bg-gray-100 text-center">
          <h2 className="text-3xl font-semibold mb-6">Kontakt</h2>
          <form
            action="https://formspree.io/f/mnndaaok"
            method="POST"
            className="max-w-xl mx-auto grid gap-4"
          >
            <input
              type="text"
              name="name"
              placeholder="Namn"
              className="p-3 border rounded-md"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="E-post"
              className="p-3 border rounded-md"
              required
            />
            <textarea
              name="message"
              placeholder="Berätta om ert bröllop"
              className="p-3 border rounded-md h-32"
              required
            ></textarea>
            <button
              type="submit"
              className="bg-black text-white py-3 px-6 rounded-lg hover:bg-gray-800 transition"
            >
              Skicka Meddelande
            </button>
          </form>
        </section>

        {/* Footer */}
        <footer className="py-6 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Rappholtphoto. Alla rättigheter förbehållna.
        </footer>
      </main>
    </>
  );
}
